import {MatPaginatorIntl} from '@angular/material/paginator';
import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class CdkMatPaginatorIntl extends MatPaginatorIntl {
    changes = new Subject<void>();
    firstPageLabel = 'Primeiro';
    itemsPerPageLabel = 'Registros por página';
    nextPageLabel = 'Seguinte';
    previousPageLabel = 'Anterior';
    lastPageLabel = 'Último';

    getRangeLabel = (page: number, pageSize: number, length: number) => {
        if (length === 0 || pageSize === 0) {
            return `Página 1 de 1`;
        }
        
        // Garante que o número da página é válido
        const totalPages = Math.ceil(length / pageSize);
        const validPage = Math.min(page, totalPages - 1);

        const startIndex = validPage * pageSize;

        const endIndex = Math.min(startIndex + pageSize, length);

        return `Página ${validPage + 1} de ${totalPages} (${startIndex + 1} a ${endIndex} de ${length}) registros`;
    }
}
